const contact = [
    {
        title: 'CODEWARS',
        source: 'https://www.codewars.com/users/iagobarretoc/badges/micro',
        alt: 'CODEWARS',
        link: 'https://www.codewars.com/users/iagobarretoc'
    },
    {
        title: 'HackerRank',
        source: 'https://img.shields.io/badge/-Hackerrank-2EC866?style=for-the-badge&logo=HackerRank&logoColor=white&link=https://www.hackerrank.com/iago_floripa',
        alt: 'HackerRank',
        link: 'https://www.hackerrank.com/iago_floripa'
    },
    {
        title: 'Buy Me a Coffee',
        source: 'https://img.shields.io/badge/Buy%20Me%20a%20Coffee-ffdd00?style=for-the-badge&logo=buy-me-a-coffee&logoColor=black&link=https://www.buymeacoffee.com/iagobar',
        alt: 'Buy Me a Coffee',
        link: 'https://www.buymeacoffee.com/iagobar'
    },
    {
        title: 'LinkedIn',
        source: 'https://img.shields.io/badge/linkedin-%230077B5.svg?style=for-the-badge&logo=linkedin&logoColor=white&link=https://www.linkedin.com/in/iagobarreto/',
        alt: 'LinkedIn',
        link: 'https://www.linkedin.com/in/iagobarreto/'
    },
    {
        title: 'CodeSandBox',
        source: 'https://img.shields.io/badge/Codesandbox-040404?style=for-the-badge&logo=codesandbox&logoColor=DBDBDB',
        alt: 'CodeSandBox',
        link: 'https://github.com/iagokrthttps://codesandbox.io/u/iagokrt'
    },
    {
        title: 'WhatsApp',
        source: 'https://camo.githubusercontent.com/d9d4db0a25f6d41d6ef282c6adc2f9bd5b31201ef00ba580f5a945da4063a937/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f57686174734170702d3235443336363f7374796c653d666f722d7468652d6261646765266c6f676f3d7768617473617070266c6f676f436f6c6f723d7768697465',
        alt: 'WhatsApp',
        link: 'https://wa.me/5548988292263?lang=pt_br'
    },
    {
        title: 'GitHub',
        source: 'https://img.shields.io/badge/github-%23121011.svg?style=for-the-badge&logo=github&logoColor=white',
        alt: 'GitHub',
        link: 'https://github.com/iagokrt'
    }
];

export default contact